import { Party } from './party';
import { VoucherResponse } from './voucher';

export enum ChequeStatus {
  PENDING = 'pending',
  CLEARED = 'cleared',
  BOUNCED = 'bounced',
  CANCELLED = 'cancelled',
}

export interface ChequeRecord {
  id: number;
  organization_id: number;
  party_id: number;
  cheque_number: string;
  cheque_date: string; // ISO date string
  clearing_date: string; // ISO date string
  amount: number;
  bank_name?: string | null;
  status: ChequeStatus;
  payment_voucher_id?: number | null;
  is_deleted: boolean;
  created_at: string;
  updated_at?: string | null;
  created_by?: number | null;
  updated_by?: number | null;

  // Relations (populated by backend)
  party?: Party;
  party_name?: string;
  voucher_number?: string | null; // Payment voucher number if cleared
  payment_voucher?: VoucherResponse | null;
}

export interface ChequeRecordCreate {
  party_id: number;
  cheque_number: string;
  cheque_date: string;
  clearing_date: string;
  amount: number;
  bank_name?: string | null;
}

export interface ChequeRecordUpdate {
  status?: 'bounced' | 'cancelled'; // Cannot set to cleared (done via payment)
  clearing_date?: string;
  bank_name?: string;
}

export interface ChequeRecordFilters {
  party_id?: number;
  status?: ChequeStatus;
  clearing_date_from?: string;
  clearing_date_to?: string;
  cheque_date_from?: string;
  cheque_date_to?: string;
  search?: string; // Searches cheque_number, bank_name
  skip?: number;
  limit?: number;
}

export interface PendingChequesParams {
  as_of_date: string; // Required - Returns pending cheques with clearing_date <= this date
}